import { SweetAlertIcon } from "sweetalert2";

/* 
    Este error se debe ejecutar cuando falle el inicio de sesion o cuando se caduque la sesion del usuario para ejecutarse deben considerar: Titulo, icono, mensaje. 
*/
export class ErrorInvalidSession implements Error {
    name!: string; // nombre del error para typescript
    message!: string; // mensaje que se va a mostrar en el console o en el sweetalert
    stack?: string | undefined; 
    title!: string;  // Titulo que se muestra en el sweet alert
    icon!: SweetAlertIcon; // icono sweeet alert
    constructor( title: string, icon: SweetAlertIcon = 'error', message?:string ) {
        this.name = "ErrorInvalidSession"
        this.title = title
        this.message = `Lo sentimos, ha ocurrido un problema con su cuenta, por favor, inicie sesión nuevamente.`
        if( message ){
            this.message = `${message}`
        }
        this.icon = icon;
    }
}

/*
    Este error se ejecuta cuando una peticion http falla, se le puede pasar un mensaje de error que de la api
*/
export class ErrorRequest implements Error {
    name!: string;
    message!: string;
    stack?: string | undefined;
    title!: string;
    icon!: SweetAlertIcon;
    constructor( title: string, icon: SweetAlertIcon = 'error', message?:string ) {
        this.name = "ErrorRequest"
        this.title = title
        this.message = `Lo sentimos, ha ocurrido un problema al intentar resolver tu solicitud, inténtelo nuevamente más tarde.`
        if( message ){
            this.message += `<div class="bg-slate-200 mt-2 p-1 text-base italic">${message}</div>`
        }
        this.icon = icon;
    }
}

/*
    Este error se ejecuta en la validacion de un campo vacio
*/
export class ErrorEmptyParam implements Error {
    name!: string;
    message!: string;
    stack?: string | undefined;
    title!: string;
    icon!: SweetAlertIcon;
    constructor( title: string, paramName: string, icon: SweetAlertIcon = 'warning' ) {
        this.name = "ErrorEmptyParam"
        this.title = title
        this.message = `Por favor, completa el campo: <br/> <div class="bg-slate-200 mt-2 p-1 text-lg font-semibold tracking-widest">${paramName}</div>`;
        this.icon = icon;
    }
}

/*
    Este error se ejecuta en la validacion de un campo con un dato incorrecto(ej: correo no valido)
*/
export class ErrorFormatParam implements Error {
    name!: string;
    message!: string;
    stack?: string | undefined;
    title!: string;
    icon!: SweetAlertIcon;
    constructor( title: string, paramName: string, icon: SweetAlertIcon = 'warning' ) {
        this.name = "ErrorFormatParam";
        this.title = title;
        this.message = `Por favor, ingresa un dato válido para: <br/> <div class="bg-slate-200 mt-2 p-1 text-lg font-semibold tracking-widest">${paramName}</div>`;
        this.icon = icon;
    }
}

/*
    Este es un error que puede ejecutar en cualquier caso, es necesario especificar el titulo , icono y mensaje de error
*/
export class ErrorCustom implements Error {
    name!: string;
    message!: string;
    stack?: string | undefined;
    title!: string;
    icon!: SweetAlertIcon;
    constructor( title: string, icon: SweetAlertIcon = 'error', message:string ) {
        this.name = "ErrorCustom"
        this.title = title
        this.message = message;
        this.icon = icon;
    }
}